import { render, staticRenderFns } from "./TransactionsQuickList.vue?vue&type=template&id=c6464544&scoped=true"
import script from "./TransactionsQuickList.vue?vue&type=script&lang=js"
export * from "./TransactionsQuickList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6464544",
  null
  
)

export default component.exports